export enum CookieKeys {
  access_token = "access_token",
  refresh_token = "refresh_token",
  language = "NEXT_LOCALE", //Don't change it, nextjs specifications
  branch_id = "branch_id",
  agent_id = "agent_id",
  currency_code = "currency_code",
  ip = "request-ip",
  rewriteURLs = "rewrite-urls",
  company_id = "company_id",
}
